import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PlansStateStructure } from 'src/app/angular-elements/plan-selection/configs/interfaces/plansStateStructure.interface';
import { Product } from 'src/app/angular-elements/plan-selection/interfaces/product.interface';
import { PlanAttributes, SummaryView } from 'src/app/angular-elements/plan-selection/interfaces/plan-attributes.interface';
import { PlanUtilityService } from 'src/app/angular-elements/plan-selection/plan-summary-list/plan-utility.service';
import moment from 'moment';
import { EffectiveDateStateStructure } from '../configs/interfaces/effective-date.state-structure.interface';
import { DateService } from 'src/app/shared/services/date.service';
import { ZipCountyStateStructure } from '../../interfaces/zipCountyStateStructure.interface';
import { EntityManagerService } from 'src/app/angular-elements/plan-selection/configs/rating-entities/entity-manager.service';
import { APP_STATE_AS_CONTENT_ENUM, APP_STATE_AS_CONTENT_ENUM_AS_JSON } from './enums/app-state-as-content.enum';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-state-as-content',
    templateUrl: './app-state-as-content.component.html',
    styleUrls: ['./app-state-as-content.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class AppStateAsContentComponent implements OnInit {

  @Input() appStateAsContent: APP_STATE_AS_CONTENT_ENUM; // 'PLAN_NAME' | 'PLAN_PRICE' | 'PLAN_COUNTY' | 'PLAN_START_DATE' | 'PLAN_RATING_ENTITY';

  retrievedStateData: string;

  enumAsJson: APP_STATE_AS_CONTENT_ENUM_AS_JSON = {
    PLAN_NAME: APP_STATE_AS_CONTENT_ENUM.PLAN_NAME,
    PLAN_PRICE: APP_STATE_AS_CONTENT_ENUM.PLAN_PRICE,
    PLAN_COUNTY: APP_STATE_AS_CONTENT_ENUM.PLAN_COUNTY,
    PLAN_START_DATE: APP_STATE_AS_CONTENT_ENUM.PLAN_START_DATE,
    PLAN_RATING_ENTITY: APP_STATE_AS_CONTENT_ENUM.PLAN_RATING_ENTITY
  }

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private planUtilityService: PlanUtilityService,
    private dateUtility: DateService,
    private entityManagerService: EntityManagerService
  ) {
  }

  ngOnInit() {
    const plansFromState = this.planUtilityService.getPlansByProductGroupAsArray();
    const planState: PlansStateStructure = this.reducerUtilityService.getState('Plans');
    const zipState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');
    const payloadState = JSON.parse(JSON.stringify(this.reducerUtilityService.getPayloadStates()));
    let effectiveDate; 
    
    if (payloadState.enrollment.coverageDate) {
      effectiveDate = this.dateUtility.getDateAsFormattedString(payloadState.enrollment.coverageDate, 'MM/DD/YYYY');
    }
    else  {
      const appStates = this.reducerUtilityService.getApplicationStates();
      const effDate = appStates.EffectiveDate as EffectiveDateStateStructure;
      effectiveDate = moment(effDate.effectiveDate).format('MM/DD/YYYY');
    }

    let matchedPlans: Product<PlanAttributes, SummaryView>[]
      = plansFromState.filter(plan => plan.attributes.PLAN_ID === planState.planIdForEnrollment);

    if (matchedPlans && matchedPlans.length > 0) {
      const productInfo: Product<PlanAttributes, SummaryView>
        = matchedPlans[0];

      switch (this.appStateAsContent) {
        case APP_STATE_AS_CONTENT_ENUM.PLAN_NAME: this.retrievedStateData = productInfo.productName; break;
        case APP_STATE_AS_CONTENT_ENUM.PLAN_PRICE: this.retrievedStateData = productInfo.price ? productInfo.price.toString() : ''; break;
        case APP_STATE_AS_CONTENT_ENUM.PLAN_COUNTY: 
          if (productInfo.attributes?.COUNTY) {
            this.retrievedStateData = productInfo.attributes?.COUNTY?.toString(); 
          }
          else {
            this.retrievedStateData = zipState.county?.county;
          }
          break;
        case APP_STATE_AS_CONTENT_ENUM.PLAN_START_DATE: this.retrievedStateData = effectiveDate; break;
        case APP_STATE_AS_CONTENT_ENUM.PLAN_RATING_ENTITY: this.retrievedStateData = this.entityManagerService.getEntityInfoByEntityId(productInfo.attributes.RATING_ENTITY)?.entity.toUpperCase()
        default: break;
      }
    }
  }
}
